<template>
  <div class="main">
        <img src="http://wechat.tianan.net/img/indexs.jpg">
        <a href="http://xav3bixg97y2fzn7.mikecrm.com/Tr5uvCi"></a>
    </div>
</template>
<script type="text/javascript" src="http://res.wx.qq.com/open/js/jweixin-1.4.0.js" ></script>
<script>
import { mapGetters, mapMutations } from 'vuex';
import $ from 'jquery';

export default {
  data() {
    return{
      scanConfig: {   // 扫码配置参数
        appId: '',
        timestamp: '',
        nonceStr: '',
        signature: '',
      },
    }
  },
  methods: {
    shere() {
      var imgUrl = 'http://wechat.tianan.net/img/det1.jpg'; 
      var lineLink = location.href.split('#')[0]; 
      var descContent = '疫情后企业面临营销危机？天安园区福利！100多位营销专家公益咨询进行中……';
      var shareTitle = '疫情后企业面临营销危机？天安园区福利！100多位营销专家公益咨询进行中……';
      var appid = '';
      this.$http.post(`${this.URL_PREFIX}/app/get/wx/jssdk/config/info`, {
          url: location.href.split('#')[0]
        }, {
          headers: { token: this.token }
        }).then((response) => {
          const res = response.data;
          if (res.resCode === '10000') {
            this.scanConfig.appId = res.resData.appId;
            this.scanConfig.timestamp = res.resData.timestamp;
            this.scanConfig.nonceStr = res.resData.nonceStr;
            this.scanConfig.signature = res.resData.signature;
            wx.config({
                debug: false,
                appId: this.scanConfig.appId,
                timestamp: this.scanConfig.timestamp,
                nonceStr: this.scanConfig.nonceStr,
                signature: this.scanConfig.signature,
                jsApiList: [
                    'checkJsApi',
                    'onMenuShareTimeline',
                    'onMenuShareAppMessage'
                ]
            });
            wx.ready(function() {
                          
                          wx.onMenuShareTimeline({
                              title: shareTitle, // 分享标题
                              link: lineLink, // 分享链接，该链接域名或路径必须与当前页面对应的公众号JS安全域名一致
                              imgUrl: imgUrl, // 分享图标
                              success: function () {
                                  // 用户确认分享后执行的回调函数
                              },
                              cancel: function () {
                                  // 用户取消分享后执行的回调函数
                              }
                          });
                          wx.onMenuShareAppMessage({
                              title: shareTitle, // 分享标题
                              desc: descContent, // 分享描述
                              link: lineLink, // 分享链接，该链接域名或路径必须与当前页面对应的公众号JS安全域名一致
                              imgUrl: imgUrl, // 分享图标
                              type: '', // 分享类型,music、video或link，不填默认为link
                              dataUrl:'' , // 如果type是music或video，则要提供数据链接，默认为空
                              success: function () {
                                  // 用户确认分享后执行的回调函数
                                  
                              },
                              cancel: function () {
                                  // 用户取消分享后执行的回调函数
                              }
                          });
                  });
          } else {
            Toast.fail({ duration: 1500, message: res.resDesc });
          }
      });
    },
  },
  mounted() {
    this.shere();
  },
  components: {
    Navigator,
  },
  computed: {
    ...mapGetters(['currentParkId','token','qrcodeServiceInfo']),
  },
}
</script>
<style lang="scss" scoped>
@import '~@scss';

.main{
    /*background: url(./index.jpg) no-repeat top center;*/
    overflow: hidden;
    position: relative;
    img{
       width: 100%; 
    }
    a{
        display: inline-block;
        width: 3.6rem;
        height: 1rem;
        position: absolute;
        bottom: .8rem;
        left: 32%;
    }
}
</style>



// WEBPACK FOOTER //
// src/pages/property/Shereye.vue